import { HorizontalScrollMaskPosition } from './horizontal-scroll.types';

export const MASK_POSITION_START: HorizontalScrollMaskPosition = 'start';
export const MASK_POSITION_END: HorizontalScrollMaskPosition = 'end';
